import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { FetchSubCategories } from '../../../store/reducers/cake_sub_category_reducer';
import CakeCard from '../components/CakeCard';
import { Col, Row } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import Breadcrumb from '../../../components/Breadcrumb';
import { Link } from 'react-router-dom';

const SubCategoryDisplay = () => {
  const subCategoryList = useSelector((state) => state?.cake_sub_categories?.subCategories);
  const dispatch = useDispatch();
  const { categoryId } = useParams();

  useEffect(() => {
    if (categoryId) {
      dispatch(FetchSubCategories(`&categoryId=${categoryId}`));
    }
  }, [categoryId]);

  return (
    <Row className="px-2">
      <Breadcrumb
        navigation={[
          { link: '/cake/home', title: 'Categories' },
          { link: '#', title: 'Sub Categories' },
        ]}
      />
      <div>
        <Link to={'/cake/home'} className="text-decoration-none">
          <button className="btn app-btn-primary mb-3 me-5">&larr; Back</button>
        </Link>
        <Link to={'/cake/orders'} className="text-decoration-none">
          <button className="btn app-btn-primary mb-3 me-5" style={{ float: 'right' }}>
            Orders
          </button>
        </Link>
      </div>
      {subCategoryList?.map((item) => {
        return (
          <Col key={item.id} style={{ cursor: 'pointer' }} className="mb-3" lg={3} md={4} xs={6} sm={6}>
            <CakeCard
              title={item?.name}
              image={`${process.env.REACT_APP_BASE_URL}/${item?.image}`}
              alt={item?.name}
              link={`/cake/product-display/${categoryId}/${item.id}`}
            />
          </Col>
        );
      })}
    </Row>
  );
};

export default SubCategoryDisplay;
